import {DomainUri} from './state/types/domain-registry.js';

// domain base URI
export const globalDomainUri: DomainUri = 'global';
export const contextDomainUri: DomainUri = 'context';

// errors
export const failure = `${globalDomainUri}.errors.failure`
